import {PersonnelService} from "@/common/api.service";
import {FETCH_CURRENCY_LIST,} from "./actions";
import {FETCH_CURRENCY_LIST_END,} from "./mutations";

const getDefaultState = () => {
    return {
        job: {},
        currencyList: [],
        fatalFetchError: {
            state: false,
            value: "",
        },
    }
};

const state = getDefaultState();

const getters = {
    currencyList(state) {
        return state.currencyList;
    },
    getCurrencyNameById: (state) => (currencyId) => {
        const currency = state.currencyList.find(currency => currency.currencyId == currencyId);
        if (currency) {
            return currency.name;
        }

    },
};

const actions = {
    [FETCH_CURRENCY_LIST]({commit}) {
        return PersonnelService.getCurrencyList()
            .then(({data}) => {
                commit(FETCH_CURRENCY_LIST_END, data);
            })
            .catch(error => {
                throw new Error(error);
            });
    },
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
    [FETCH_CURRENCY_LIST_END](state, data) {
        state.currencyList = data;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
